import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import useClickOutside from '@rooks/use-outside-click-ref';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

import { useGlobal } from 'context/Global';
import Portal from './Portal';

const Modal = ({ show, onHide, children }) => {
  const [modalRef] = useClickOutside(onHide);
  const { lockScroll, unlockScroll } = useGlobal();

  React.useEffect(() => {
    if (show) lockScroll();
    return () => unlockScroll();
  }, [show, lockScroll, unlockScroll]);

  return (
    <Portal id="modals">
      <AnimatePresence>
        {show && (
          <motion.div
            key="modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 w-full h-full z-40 flex justify-center items-end lg:items-center lg:p-12 overflow-y-auto"
          >
            <div className="absolute inset-0 bg-gray-darker opacity-75" />
            <motion.div
              className="overflow-y-auto overflow-x-hidden max-h-full relative bg-gray-dark shadow-xl w-full rounded-t-xl lg:rounded-b-xl lg:max-w-2xl"
              ref={modalRef}
              initial={{ y: 100 }}
              animate={{ y: 0 }}
              transition={{ duration: 0.25, delay: 0.25 }}
            >
              {children}
            </motion.div>
            <button
              type="button"
              onClick={onHide}
              className="w-12 h-12 flex lg:hidden justify-center items-center bg-gray-dark rounded-full shadow-lg fixed right-0 top-0 mt-3 mr-3 text-2xl text-gray-200"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </Portal>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

Modal.defaultProps = {
  show: false,
};

export default Modal;
